module.exports = {"id":"178249","name":"Jirès Kembo-Ekoko","rating":"74","photo":"./data/images/photos/2/178249.png","club":{"name":"Bursaspor","logo":"./data/images/clubs/Bursaspor.png"},"positions":["AD","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JiresKembo-Ekoko0.json
// module id = 2022
// module chunks = 0